import { render, staticRenderFns } from "./view-invoice.vue?vue&type=template&id=854fedb4&scoped=true"
import script from "./view-invoice.vue?vue&type=script&lang=js"
export * from "./view-invoice.vue?vue&type=script&lang=js"
import style0 from "./view-invoice.vue?vue&type=style&index=0&id=854fedb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854fedb4",
  null
  
)

export default component.exports